<template>
  <div class="space-y-5">
    <div class="space-y-4">
      <checkout-data-field
        v-for="item in individualFields"
        :key="item.id"
        :field="item"
        @delete-field="deleteField(item.id)"
      />
      <checkout-data-table
        v-for="item in tables"
        :key="item.id"
        :table="item"
        @delete-field="deleteField(item.id)"
      />
    </div>
    <checkout-data-step-add-item-button
      @field:select="addField"
      @table:select="addField"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { storeToRefs } from "pinia";

import {
  checkoutBaseToDedicatedStep,
  isIndividualField,
  isTable,
} from "@/helpers/checkout";
import { useCheckoutStore } from "@/stores/checkout";

import CheckoutDataField from "@/views/checkout/components/CheckoutDataField.vue";
import CheckoutDataStepAddItemButton from "@/views/checkout/components/CheckoutDataStepAddItemButton.vue";
import CheckoutDataTable from "@/views/checkout/components/CheckoutDataTable.vue";

import type { CheckoutDataStepItem } from "@/models/checkout";

const { selectedStep } = storeToRefs(useCheckoutStore());

const dataStep = computed(() =>
  checkoutBaseToDedicatedStep(selectedStep.value, "data")
);

const individualFields = computed(
  () => dataStep.value?.items?.filter(isIndividualField) ?? []
);

const tables = computed(() => dataStep.value?.items?.filter(isTable) ?? []);

const addField = (field: CheckoutDataStepItem) => {
  if (!dataStep.value) {
    return;
  }

  if (!dataStep.value.items) {
    dataStep.value.items = [];
  }

  dataStep.value.items.push(field);
};

const deleteField = (itemId: string) => {
  if (!dataStep.value?.items) {
    return;
  }

  const indexOfItemToRemove = dataStep.value.items.findIndex(
    (item) => item.id === itemId
  );

  if (indexOfItemToRemove === -1) {
    return;
  }

  dataStep.value.items.splice(indexOfItemToRemove, 1);
};
</script>
